// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Seç',
    titleLinkTooltip: 'Sayfaya git',
    collapseCardTooltip: 'Kartı daralt',
    expandCardTooltip: 'Kartı genişlet'
  },
  CardList: {
    loadMore: 'Daha fazlasını yükle',
    notFound: 'Hiçbir öğe bulunmadı.',
    toolbarSelect: 'Seç',
    viewCards: 'Kartlar',
    viewTiles: 'Döşemeler',
    viewList: 'Liste',
    toolbarView: 'Görüntüleme'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Ayrıl',
    cancel: 'Geri Dön',
    content: 'Bu pencereyi kapatıp ayrılmak istediğinizden emin misiniz? Yaptığınız hiçbir veri değişikliği kaydedilmeyecektir.'
  },
  Cuttable: {
    showMore: 'Daha fazla göster',
    showLess: 'Daha az göster'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'İptal'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'İptal'
  },
  Dropdown: {
    close: 'Kapat'
  },
  Form: {
    submitButton: 'Kaydet',
    applyButton: 'Uygula',
    cancelButton: 'İptal'
  },
  FormField: {
    clear: 'Temizle',
    remove: 'Sil',
    addMore: 'Bir tane daha ekle',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Şifrenizi iyileştirmek için:',
    passwordTooShort: 'Şifreyi uzatın.',
    lettersLowerCase: 'En az bir küçük harf kullanın.',
    lettersUpperCase: 'En az bir büyük harf kullanın.',
    numbers1: 'En az bir rakam kullanın.',
    numbers3: 'En az üç rakam kullanın.',
    specialChar1: 'En az bir özel karakter kullanın (örneğin: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'En az iki özel karakter kullanın (örneğin: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Hem büyük harf hem de küçük harf kullanın.',
    comboLettersAndNumbers: 'Hem rakamlar hem de karakterler kullanın.',
    comboLettersNumbersSpecial: 'Rakamlar, karakterler ve özel karakterler kullanın.',
    yourPasswordIsStrong: 'Uzunluğunu artırarak şifrenizi daha da güçlü hâle getirebilirsiniz.',
    passwordStrength: 'Şifre gücü: %%strength%%.',
    strengthVeryStrong: 'ÇOK GÜÇLÜ',
    strengthStrong: 'GÜÇLÜ',
    strengthVeryWeak: 'ÇOK ZAYIF',
    strengthWeak: 'ZAYIF',
    strengthMedium: 'ORTA',
    hidePassword: 'Şifreyi gizle',
    showPassword: 'Şifreyi göster',
    generateButton: 'Üret',
    copyButtonHint: 'Şifreyi kopyalayın',
    copySuccessToast: 'Şifre kopyalandı',
    generateButtonHint: 'Güçlü bir şifre üretin'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Değişiklikleri iptal edin',
    editButtonHint: 'Değeri düzenleyin',
    okButtonHint: 'Değişiklikleri kaydedin'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Dosya seç...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Toplam %%totalRows%% öğe',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%%/%%totalRows%% öğe seçildi',
    all: 'Hepsi',
    allItemsOnPageSelected: 'Sayfadaki öğelerin hepsi seçildi',
    allItemsSelected: 'Öğelerin hepsi seçildi',
    selectAllItems: 'Öğelerin hepsini seç',
    selectAllItemsOnPage: 'Sayfadaki öğelerin hepsini seç',
    deselectAll: 'Seçimi kaldır',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Filtre ile eşleşen herhangi bir öğe bulunamadı',
    emptyTitle: 'Görünüşe göre burada bir şey yok',
    filteredDescription: 'Sorgunuzu düzenleyin veya filtredeki bazı kriterleri kaldırıp tekrar deneyin.'
  },
  ListOperation: {
    cancelButton: 'İptal'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: '/%%total%%',
    itemsPerPage: 'Sayfa başına öğe',
    all: 'Hepsi',
    total: 'Sayfa %%current%%/%%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Kapat',
    cancelButton: 'İptal'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Seçenek yok',
    placeholder: 'Seç...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%%/%%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Grubu kapat'
  },
  Toast: {
    closeButton: 'Close'
  }
};